<template>
	<span>{{ minutes }}:{{ seconds | twoDigits }}</span>
</template>

<script>

import { eventBus } from './../main'

let interval = null;
export default {
    name: 'Countdown',
    props: {
        end: {
            type: Date
        },
        stop: {
            type: Boolean
        }
    },
    data() {
        return {
            now: Math.trunc((new Date()).getTime() / 1000),
            date: null,
            diff: 0
        }
    },
    created() {
		if (!this.end) {
			throw new Error("Missing props 'deadline' or 'end'");
		}
		
		this.date = Math.trunc(this.end.getTime() / 1000);

		this.init();

		// update the timer with new value
		eventBus.$on('updateTimer', (data) => {
			var newDate = new Date(data);
			this.date = Math.trunc(newDate.getTime() / 1000);
			this.init();
		});

    },
    computed: {
        seconds() {
            return Math.trunc(this.diff) % 60
        },
        minutes() {
            return Math.trunc(this.diff / 60) % 60
        },
        hours() {
            return Math.trunc(this.diff / 60 / 60) % 24
        },
        days() {
            return Math.trunc(this.diff / 60 / 60 / 24)
        }
	},
	methods:{
		init(){

			if (!this.date) {
				throw new Error("Invalid props value for 'end'");
			}

			// these two lines initialize the countdown so we start at the correct time (instead of starting at 0:00)
			this.now = Math.trunc((new Date()).getTime() / 1000);
			this.diff = this.date - this.now;

			interval = setInterval(() => {
				this.now = Math.trunc((new Date()).getTime() / 1000);
			}, 1000);

			eventBus.$on('pauseCountdown', () => {
				clearInterval(interval);
			});

			eventBus.$on('resumeCountdown', () => {
				interval = setInterval(() => {
					this.now = Math.trunc((new Date()).getTime() / 1000);
				}, 1000);
			});
		}
	},
    watch: {
        // eslint-disable-next-line
        now(value) {
            this.diff = this.date - this.now;
            if(this.diff <= 0 || this.stop){
				this.diff = 0;
				
				this.$emit('finished', true);

                // Remove interval
				clearInterval(interval);
            }
        }
    },
    filters: {
        twoDigits(value) {
            if ( value.toString().length <= 1 ) {
                return '0'+value.toString()
            }
            return value.toString()
        }
    },
    destroyed() {
        clearInterval(interval);
    }
}
</script>